// import React, { useContext, useState } from "react";
// import "./auth.scss";
// import LogoGMIM from "../../assets/LogoGMIM.png";
// import { Link, useNavigate } from "react-router-dom";
// import { auth, db } from "../../config/firebase";
// import { signInWithEmailAndPassword, signOut } from "firebase/auth";
// import { ref, get } from "firebase/database";
// import backEndDataContext from "../../contexts/backendDataContexts";

// const Login = () => {
//   const [email, setEmail] = useState("");
//   const [password, setPassword] = useState("");
//   const [loading, setLoading] = useState(false);
//   const [message, setMessage] = useState(null);
//   const backEndData = useContext(backEndDataContext);

//   const navigate = useNavigate();

//   const handleLogin = async (e) => {
//     e.preventDefault();
//     setLoading(true);
//     setMessage(null);

//     try {
//       const userCredential = await signInWithEmailAndPassword(
//         auth,
//         email,
//         password
//       );
//       const user = userCredential.user;

//       const userRef = ref(db, "users/" + user.uid);
//       const snapshot = await get(userRef);

//       if (snapshot.exists()) {
//         const userData = snapshot.val();

//         if (!userData.verified) {
//           setMessage({
//             type: "error",
//             text: "Akun Anda belum diverifikasi oleh Admin.",
//           });
//           await signOut(auth);
//           return;
//         }

//         if (userData.role === "admin") {
//           backEndData.setUserDetail({ uid: user.uid, ...userData });
//           navigate("/admin");
//         } else if (userData.role === "operator") {
//           backEndData.setUserDetail({ uid: user.uid, ...userData });
//           navigate("/operator");
//         } else {
//           setMessage({
//             type: "error",
//             text: "Role pengguna tidak dikenali.",
//           });
//         }
//       } else {
//         setMessage({
//           type: "error",
//           text: "Data pengguna tidak ditemukan di database.",
//         });
//         await signOut(auth);
//       }
//     } catch (error) {
//       console.error("Login error:", error);
//       let errorText = "Terjadi kesalahan saat login.";

//       switch (error.code) {
//         case "auth/invalid-email":
//           errorText = "Format email tidak valid.";
//           break;
//         case "auth/user-not-found":
//           errorText = "Akun tidak ditemukan.";
//           break;
//         case "auth/invalid-credential":
//           errorText = "Username atau Password salah.";
//           break;
//         case "auth/too-many-requests":
//           errorText = "Terlalu banyak percobaan login gagal. Coba lagi nanti.";
//           break;
//         default:
//           errorText = error.message || "Login gagal.";
//       }

//       setMessage({
//         type: "error",
//         text: errorText,
//       });
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <div className="auth-page">
//       <div className="auth-card">
//         <img src={LogoGMIM} alt="Logo GMIM" className="auth-logo" />

//         <h2 className="auth-title">Login Admin & Operator Web</h2>
//         <p className="auth-subtitle">GMIM "GENESARET" PATETEN</p>

//         {/* Pesan status */}
//         {message && (
//           <div
//             className={`auth-message ${
//               message.type === "success" ? "success" : "error"
//             }`}
//           >
//             {message.text}
//           </div>
//         )}

//         <form onSubmit={handleLogin}>
//           <input
//             type="email"
//             placeholder="Masukkan email anda"
//             className="auth-input"
//             value={email}
//             onChange={(e) => setEmail(e.target.value)}
//             required
//           />
//           <input
//             type="password"
//             placeholder="Masukkan password anda"
//             className="auth-input"
//             value={password}
//             onChange={(e) => setPassword(e.target.value)}
//             required
//           />
//           <button
//             type="submit"
//             className={`auth-button ${loading ? "disabled" : ""}`}
//             disabled={loading}
//           >
//             {loading ? "Memproses..." : "Login"}
//           </button>
//         </form>

//         <p className="auth-footer">
//           Belum punya akun?
//           <Link to="/register">Daftar di sini</Link>
//         </p>

//         {/* Tombol kembali ke beranda */}
//         <div className="back-home-wrapper">
//           <Link to="/" className="back-home-link">
//             ← Kembali ke Beranda
//           </Link>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Login;

import React, { useContext, useState } from "react";
import "./auth.scss";
import LogoGMIM from "../../assets/LogoGMIM.png";
import { Link, useNavigate } from "react-router-dom";
import { auth, db } from "../../config/firebase";
import { signInWithEmailAndPassword, signOut } from "firebase/auth";
import { ref, get, update } from "firebase/database"; // ⬅️ tambahkan "update"
import backEndDataContext from "../../contexts/backendDataContexts";

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState(null);
  const backEndData = useContext(backEndDataContext);

  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage(null);

    try {
      // 🔹 1. Login ke Firebase Auth
      const userCredential = await signInWithEmailAndPassword(auth, email, password);
      const user = userCredential.user;

      // 🔹 2. Ambil data user dari Realtime Database
      const userRef = ref(db, "users/" + user.uid);
      const snapshot = await get(userRef);

      if (!snapshot.exists()) {
        setMessage({
          type: "error",
          text: "Data pengguna tidak ditemukan di database.",
        });
        await signOut(auth);
        return;
      }

      const userData = snapshot.val();

      // 🔹 3. Cek status verifikasi
      if (!userData.verified) {
        setMessage({
          type: "error",
          text: "Akun Anda belum diverifikasi oleh Admin.",
        });
        await signOut(auth);
        return;
      }

      // 🔹 4. Update waktu login terakhir
      await update(userRef, {
        lastLogin: Date.now(),
      });

      // 🔹 5. Simpan data user di context
      backEndData.setUserDetail({ uid: user.uid, ...userData });

      // 🔹 6. Arahkan sesuai role
      if (userData.role === "admin") {
        navigate("/admin");
      } else if (userData.role === "operator") {
        navigate("/operator");
      } else {
        setMessage({
          type: "error",
          text: "Role pengguna tidak dikenali.",
        });
      }
    } catch (error) {
      console.error("Login error:", error);

      let errorText = "Terjadi kesalahan saat login.";
      switch (error.code) {
        case "auth/invalid-email":
          errorText = "Format email tidak valid.";
          break;
        case "auth/user-not-found":
          errorText = "Akun tidak ditemukan.";
          break;
        case "auth/invalid-credential":
          errorText = "Username atau Password salah.";
          break;
        case "auth/too-many-requests":
          errorText = "Terlalu banyak percobaan login gagal. Coba lagi nanti.";
          break;
        default:
          errorText = error.message || "Login gagal.";
      }

      setMessage({ type: "error", text: errorText });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-card">
        <img src={LogoGMIM} alt="Logo GMIM" className="auth-logo" />

        <h2 className="auth-title">Login Admin & Operator Web</h2>
        <p className="auth-subtitle">GMIM "GENESARET" PATETEN</p>

        {/* Pesan status */}
        {message && (
          <div
            className={`auth-message ${
              message.type === "success" ? "success" : "error"
            }`}
          >
            {message.text}
          </div>
        )}

        <form onSubmit={handleLogin}>
          <input
            type="email"
            placeholder="Masukkan email anda"
            className="auth-input"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
          <input
            type="password"
            placeholder="Masukkan password anda"
            className="auth-input"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
          <button
            type="submit"
            className={`auth-button ${loading ? "disabled" : ""}`}
            disabled={loading}
          >
            {loading ? "Memproses..." : "Login"}
          </button>
        </form>

        <p className="auth-footer">
          Belum punya akun?
          <Link to="/register">Daftar di sini</Link>
        </p>

        <div className="back-home-wrapper">
          <Link to="/" className="back-home-link">
            ← Kembali ke Beranda
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Login;

